// function card() {
//   return { padding: '5px' }
// }

export default {
  card:{ padding: '5px' }
};



// WEBPACK FOOTER //
// ./src/tools/style.js